export interface LoyaltyCreditCardFeatureFlag {
  hasResolvedFlag: boolean
  isEnabled: boolean
  /** The visitor has to log in before we can tell whether the page is theirs to see. */
  requiresLogin: boolean
}

// Credit card availability requires both the AU region and an enabled LE Lab
// decision. Non-AU regions resolve as disabled immediately; AU remains
// unresolved until LE Lab returns a decision. Bots may remain unresolved
// because they skip the LE Lab request.
export function resolveLoyaltyCreditCardFeatureFlag(
  flag: App.LabFeatureFlagResult | undefined,
  currentRegionCode: string,
  isLoggedIn: boolean,
): LoyaltyCreditCardFeatureFlag {
  // An empty region means geo state has not resolved (or failed), not that
  // the visitor is outside AU — fall through so the page keeps loading rather
  // than bouncing a possibly-AU visitor.
  if (currentRegionCode && currentRegionCode !== 'AU') {
    return {
      hasResolvedFlag: true,
      isEnabled: false,
      requiresLogin: false,
    }
  }

  const hasResolvedFlag = flag !== undefined
  const isEnabled = !!flag?.enabled

  // While the campaign is limited to a staff audience, a logged-out visitor
  // can never match it, so a disabled decision says nothing about whether
  // they are allowed in — ask them to log in instead of redirecting them
  // away. Once the audience opens to everyone, logged-out visitors resolve as
  // enabled and this stops applying on its own.
  return {
    hasResolvedFlag,
    isEnabled,
    requiresLogin: hasResolvedFlag && !isEnabled && !isLoggedIn,
  }
}
